import { IDBPDatabase } from 'idb'
import { IDBSchema } from '../types'

/**
 * CHANGES:
 *
 * - Created `projects` table
 * - Created `openTabs` table
 * - Created `sessions` table
 * - Created `scripts` table
 */

export default (
  database: IDBPDatabase<IDBSchema>,
  transaction: IDBTransaction,
  next: () => void
) => {
  STUDIO_ENV_DEVELOPMENT && console.log('---Running migration for v1---')

  database.createObjectStore('projects', { keyPath: 'id' })
  STUDIO_ENV_DEVELOPMENT && console.log('Created projects table')

  database.createObjectStore('openTabs', { keyPath: 'id' })
  STUDIO_ENV_DEVELOPMENT && console.log('Created openTabs table')

  database.createObjectStore('sessions', { keyPath: 'id' })
  STUDIO_ENV_DEVELOPMENT && console.log('Created sessions table')

  database.createObjectStore('scripts', { keyPath: 'id' })
  STUDIO_ENV_DEVELOPMENT && console.log('Created scripts table')

  STUDIO_ENV_DEVELOPMENT && console.log('---Migrated to v1---')
  return next()
}
